module.exports = __webpack_public_path__ + "static/media/cosmo.3b8418ef.jpg";